import { AIAliasRegistry } from '../AIAliasRegistry';

AIAliasRegistry.getInstance().registerAlias({
  alias: 'actif',
  nature: 'data',
  table: 'actifs',
  key: 'symbole',
  label: 'Actif financier',
  description: 'Recherche un actif par son symbole boursier',
  icon: '📈',
  examples: ['$actif:PAAS', '$actif:GOLD;2025-01-01-2026-01-01'],
});
